/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface GeoFormData
 */
export interface GeoFormData {
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof GeoFormData
     */
    region?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof GeoFormData
     */
    country?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof GeoFormData
     */
    location?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof GeoFormData
     */
    station?: GuidIdCodeAndLabel;
}

export function GeoFormDataFromJSON(json: any): GeoFormData {
    return GeoFormDataFromJSONTyped(json, false);
}

export function GeoFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'region': !exists(json, 'region') ? undefined : GuidIdCodeAndLabelFromJSON(json['region']),
        'country': !exists(json, 'country') ? undefined : GuidIdCodeAndLabelFromJSON(json['country']),
        'location': !exists(json, 'location') ? undefined : GuidIdCodeAndLabelFromJSON(json['location']),
        'station': !exists(json, 'station') ? undefined : GuidIdCodeAndLabelFromJSON(json['station']),
    };
}

export function GeoFormDataToJSON(value?: GeoFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'region': GuidIdCodeAndLabelToJSON(value.region),
        'country': GuidIdCodeAndLabelToJSON(value.country),
        'location': GuidIdCodeAndLabelToJSON(value.location),
        'station': GuidIdCodeAndLabelToJSON(value.station),
    };
}


